export const registerTh = {
    //fill contact number
    contact_number: {
        name: 'กรุณากรอกเบอร์โทรศัพท์มือถือ',
        placeholder: 'กรอกเบอร์โทรศัพท์',
        required: 'กรุณากรอกเบอร์โทรศัพท์มือถือ',
        too_short: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
        invalid: 'เบอร์โทรศัพท์มือถือไม่ถูกต้อง',
    },

    resend_otp_btn: 'ขอรหัส OTP อีกครั้ง',

    enter_contact_number_btn: 'ถัดไป',
    //end fill contact number
    //select user type
    select_user_headline: 'กรุณาเลือกประเภทการสมัครสมาชิก',
    select_user_subheadline_1: 'หากต้องการเปลี่ยนแปลงการลงทะเบียน',
    select_user_subheadline_2: 'โปรดติดต่อ CPF',

    user_farmer: 'เกษตรกร',
    user_subdist: 'ตัวแทนจำหน่ายย่อย',
    user_dist: 'ตัวแทนจำหน่าย',
    user_sale: 'พนักงานส่งเสริมบริการ',

    select_user_type_btn: 'ถัดไป',
    //end select user type
    //register form
    register_form_navbar_name: 'ลงทะเบียน',
    register_form_farmer_navbar_name: 'ลงทะเบียนเกษตรกร',
    register_form_subdist_navbar_name: 'ลงทะเบียนตัวแทนจำหน่ายย่อย',
    register_form_dist_navbar_name: 'ลงทะเบียนตัวแทนจำหน่าย',
    register_form_sale_navbar_name: 'ลงทะเบียนพนักงานส่งเสริมบริการ',
    register_form_headline: 'ข้อมูลส่วนตัว',
    name: {
        name: '',
        placeholder: 'ชื่อจริง',
        required: 'กรุณากรอกชื่อจริง',
        too_short: '',
        invalid: '',
    },
    lastname: {
        name: '',
        placeholder: 'นามสกุล',
        required: 'กรุณากรอกนามสกุล',
        too_short: '',
        invalid: '',
    },
    email: {
        name: '',
        placeholder: 'อีเมล์',
        required: 'กรุณากรอกอีเมล์',
        too_short: '',
        invalid: 'อีเมล์ของคุณไม่ถูกต้อง',
        optional: '(ถ้ามี)'
    },
    contact_number_register: {
        name: '',
        placeholder: '',
        required: '',
        too_short: '',
        invalid: '',
    },
    birthdate: {
        name: 'วันเกิด',
        warning: '(ต้องมีอายุครบ 20 ปีบริบูรณ์ถึงจะใช้งานได้)',
        required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        day: {
            name: 'วัน',
            placeholder: 'วัน',
            required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            too_short: '',
            invalid: '',
        },
        month: {
            name: 'เดือน',
            placeholder: 'เดือน',
            required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            too_short: '',
            invalid: '',
        },
        year: {
            name: 'ปี พ.ศ.',
            placeholder: 'ปี พ.ศ.',
            required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
            too_short: '',
            invalid: 'ขออภัยค่ะ อายุของคุณไม่ถึงเกณฑ์การใช้งานระบบ',
        },
        warning_age: 'ขออภัยค่ะ อายุของคุณไม่ถึงเกณฑ์การใช้งานระบบ'
    },

    shop_input_label: 'ร้านตัวแทนจำหน่ายอาหารสัตว์ในพื้นที่ของท่าน',
    shop_text_warning: '(กรุณาตรวจสอบร้านค้าตัวแทนจำหน่ายอาหารสัตว์ที่ท่านใช้บริการ)',
    form_error_label: 'กรุณากรอกข้อมูลให้ครบถ้วน',
    province: {
        name: '',
        placeholder: 'กรุณาเลือกจังหวัด',
        required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        too_short: '',
        invalid: ''
    },
    shop: {
        name: '',
        placeholder: 'กรุณาเลือกร้านค้า',
        required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        too_short: '',
        invalid: ''
    },
    other_shop: {
        name: '',
        placeholder: 'ระบุชื่อร้านค้า กรณีเลือกอื่นๆ',
        required: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        too_short: '',
        invalid: ''
    },

    fields_required: 'กรุณากรอกข้อมูลให้ครบถ้วน',

    livestock_headline: 'กรุณาระบุข้อมูลสัตว์เลี้ยง',
    livestock_unit: 'ตัว',
    livestock_selected_require: 'กรุณากรอกข้อมูลให้ครบถ้วนค่ะ<br/>(บังคับการระบุจำนวนขั้นต่ำ 1 ชนิด)',
    livestock_selected_name_require: 'กรุณาระบุชื่อของข้อมูลสัตว์ที่เลี้ยง',
    livestock_selected_amount_require: 'กรุณาระบุจำนวนของข้อมูลสัตว์ที่เลี้ยง',

    livestock_name_placeholder: 'กรอกชื่อสัตว์',
    livestock_amount_placeholder: 'กรอกจำนวน',
    livestock_add_breed: '+ เพิ่มสัตว์อื่นๆ',
    livestock_remove_breed: 'ลบ',

    terms_1: 'ฉันได้อ่านและยอมรับ ',
    terms_2: ' ข้อกำหนดการใช้งานและนโยบายความเป็นส่วนตัว',
    terms_3: ' ของ CPF',
    terms_accept_require: 'กรุณายอมรับข้อกำหนดการใช้งานและนโยบายความเป็นส่วนตัว',
    marketing: {
        title: 'ข่าวสารและโปรโมชั่น',
        msg: 'โปรดเลือกช่องทาง<br/>การรับข่าวสารและโปรโมชั่น',

        close_modal: {
            title: 'ไม่รับข่าวสาร',
            msg: 'คุณจะพลาดข่าวสารและโปรโมชั่นดีๆไปนะ',
            btn_setting: 'ตั้งค่าช่องทางการรับข่าวสาร',
            btn_not_recive: 'ไม่รับข่าวสารและโปรโมชั่น'
        }
    },

    submit_form_btn: 'ถัดไป',

    success_title: 'ลงทะเบียนเรียบร้อยแล้ว',
    success_msg: 'คุณได้ลงทะเบียนเรียบร้อยแล้ว',
    success_close: 'ปิด',
    success_reward: 'ดูสิทธิพิเศษ',

    terms_headline_modal: 'ข้อกำหนดการใช้งานและ<br/>นโยบายความเป็นส่วนตัว',
    btn_accept: 'ยอมรับ',
    btn_close: 'ปิด',
    tab_to_bottom: 'Tab to bottom',

    register_alert_headline: 'เกิดข้อผิดพลาด',
    register_alert_btn: 'ตกลง',
    err_403: {
        title: 'ขออภัย',
        msg: 'กรุณาเข้ามาสมัครสมาชิกใหม่ภายใน 30 วัน นับจากวันที่กดยกเลิกสมาชิก'
    },
    //end register form

    modal_welcome:{
        title: 'Welcome Point',
        message: 'รับฟรี! {0} คะแนน',
    },
    modal_register_success:{
        title: 'ยินดีด้วย',
        message: 'คุณสร้างบัญชีผู้ใช้สำเร็จ',
    },
    err_exist_user: {
        title: 'ขออภัย',
        msg: 'เบอร์โทรศัพท์ของท่านเคยมีอยู่ในระบบแล้ว กรุณาตรวจสอบอีกครั้ง'
    },
    err_fruad: {
        title: 'ขออภัย',
        msg: 'กรุณาตรวจสอบสิทธิการใช้งานที่ Call Center หมายเลข 02-036-4501 เพื่อยืนยันตัวตนในการรับสิทธิค่ะ'
    },
}
